import palette from './palette';

export default {
  h1: {
    color: palette.text.primary,
    fontWeight: 600,
    fontSize: '30px',
    lineHeight: '40px',
    fontFamily:"Lato"
  },
  h2: {
    color: palette.text.primary,
    fontWeight: 500,
    fontSize: '25px',
    lineHeight: '32px',
    fontFamily: "Lato"
  },
  h3: {
    color: palette.text.primary,
    fontWeight: 500,
    fontSize: '20px',
    lineHeight: '25px',
    fontFamily: "Lato"
  },
  h4: {
    color: palette.text.primary,
    fontWeight: "bolder",
    fontSize: '16px',
    lineHeight: '24px',
    fontFamily: "Lato"
  },
  h5: {
    color: palette.text.primary,
    fontWeight: 500,
    fontSize: '14px',
    lineHeight: '20px',
    fontFamily: "Lato"
  },
  h6: {
    color: palette.text.primary,
    fontWeight: 500,
    fontSize: '12px',
    lineHeight: '20px',
    fontFamily: "Lato"
  },
  subtitle1: {
    color: palette.text.primary,
    fontSize: '14px',
    lineHeight: '25px',
    fontFamily: "Lato"
  },
  subtitle2: {
    color: palette.text.secondary,
    fontWeight: 400,
    fontSize: '12px',
    lineHeight: '15px',
    fontFamily: "Lato"
  },
  body1: {
    color: palette.text.primary,
    fontSize: '12px',
    lineHeight: '15px',
    fontFamily: "Lato"
  },
  body2: {
    color: palette.text.secondary,
    fontSize: '12px',
    letterSpacing: '-0.04px',
    lineHeight: '18px',
    fontFamily: "Lato"
  },
  button: {
    color: palette.text.primary,
    fontSize: '14px',
    lineHeight: "14px",
    fontFamily: "Lato"
  },
  caption: {
    color: palette.text.secondary,
    fontSize: '11px',
    letterSpacing: '0.33px',
    lineHeight: '13px',
    fontFamily: "Lato"
  },
  overline: {
    color: palette.text.secondary,
    fontSize: '11px',
    fontWeight: 500,
    letterSpacing: '0.33px',
    lineHeight: '13px',
    textTransform: 'uppercase',
    fontFamily: "Lato"
  }
};
